export const ADMISSIONSDASHBOARD_QUERY_KEYS = {
  GET: ['admissionsdashboard'] as const,
} as const
